export default "__VITE_PUBLIC_ASSET__1f350ee1__"